!function() {
  "use strict";

  // Existing map styles (no change here)
  var e = {};
  e.basic = [];
  e.light = [{
    featureType: "administrative",
    elementType: "labels",
    stylers: [{
      visibility: "simplified"
    }, {
      lightness: "64"
    }, {
      hue: "#ff0000"
    }]
  }, {
    featureType: "administrative",
    elementType: "labels.text.fill",
    stylers: [{
      color: "#bdbdbd"
    }]
  }, {
    featureType: "administrative",
    elementType: "labels.icon",
    stylers: [{
      visibility: "off"
    }]
  }, {
    featureType: "landscape",
    elementType: "all",
    stylers: [{
      color: "#f0f0f0"
    }, {
      visibility: "simplified"
    }]
  }, {
    featureType: "landscape.natural.landcover",
    elementType: "all",
    stylers: [{
      visibility: "off"
    }]
  }, {
    featureType: "landscape.natural.terrain",
    elementType: "all",
    stylers: [{
      visibility: "off"
    }]
  }, {
    featureType: "poi",
    elementType: "all",
    stylers: [{
      visibility: "off"
    }]
  }, {
    featureType: "poi",
    elementType: "geometry.fill",
    stylers: [{
      visibility: "off"
    }]
  }, {
    featureType: "poi",
    elementType: "labels",
    stylers: [{
      lightness: "100"
    }]
  }, {
    featureType: "poi.park",
    elementType: "all",
    stylers: [{
      visibility: "on"
    }]
  }, {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [{
      saturation: "-41"
    }, {
      color: "#e8ede7"
    }]
  }, {
    featureType: "poi.park",
    elementType: "labels",
    stylers: [{
      visibility: "off"
    }]
  }, {
    featureType: "road",
    elementType: "all",
    stylers: [{
      saturation: "-100"
    }]
  }, {
    featureType: "road",
    elementType: "labels",
    stylers: [{
      lightness: "25"
    }, {
      gamma: "1.06"
    }, {
      saturation: "-100"
    }]
  }, {
    featureType: "road.highway",
    elementType: "all",
    stylers: [{
      visibility: "simplified"
    }]
  }, {
    featureType: "road.highway",
    elementType: "geometry.fill",
    stylers: [{
      gamma: "10.00"
    }]
  }, {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [{
      weight: "0.01"
    }, {
      visibility: "simplified"
    }]
  }, {
    featureType: "road.highway",
    elementType: "labels",
    stylers: [{
      visibility: "off"
    }]
  }, {
    featureType: "road.highway",
    elementType: "labels.text.fill",
    stylers: [{
      weight: "0.01"
    }]
  }, {
    featureType: "road.highway",
    elementType: "labels.text.stroke",
    stylers: [{
      weight: "0.01"
    }]
  }, {
    featureType: "road.arterial",
    elementType: "geometry.fill",
    stylers: [{
      weight: "0.8"
    }]
  }, {
    featureType: "road.arterial",
    elementType: "geometry.stroke",
    stylers: [{
      weight: "0.01"
    }]
  }, {
    featureType: "road.arterial",
    elementType: "labels.icon",
    stylers: [{
      visibility: "off"
    }]
  }, {
    featureType: "road.local",
    elementType: "geometry.fill",
    stylers: [{
      weight: "0.01"
    }]
  }, {
    featureType: "road.local",
    elementType: "geometry.stroke",
    stylers: [{
      gamma: "10.00"
    }, {
      lightness: "100"
    }, {
      weight: "0.4"
    }]
  }, {
    featureType: "road.local",
    elementType: "labels",
    stylers: [{
      visibility: "simplified"
    }, {
      weight: "0.01"
    }, {
      lightness: "39"
    }]
  }, {
    featureType: "road.local",
    elementType: "labels.text.stroke",
    stylers: [{
      weight: "0.50"
    }, {
      gamma: "10.00"
    }, {
      lightness: "100"
    }]
  }, {
    featureType: "transit",
    elementType: "all",
    stylers: [{
      visibility: "off"
    }]
  }, {
    featureType: "water",
    elementType: "all",
    stylers: [{
      color: "#cfe5ee"
    }, {
      visibility: "on"
    }]
  }], e.white_label = [{
    featureType: "all",
    elementType: "all",
    stylers: [{
      visibility: "simplified"
    }]
  }, {
    featureType: "all",
    elementType: "labels",
    stylers: [{
      visibility: "simplified"
    }]
  }, {
    featureType: "administrative",
    elementType: "labels",
    stylers: [{
      gamma: "3.86"
    }, {
      lightness: "100"
    }]
  }, {
    featureType: "administrative",
    elementType: "labels.text.fill",
    stylers: [{
      color: "#cccccc"
    }]
  }, {
    featureType: "landscape",
    elementType: "all",
    stylers: [{
      color: "#f2f2f2"
    }]
  }, {
    featureType: "poi",
    elementType: "all",
    stylers: [{
      visibility: "off"
    }]
  }, {
    featureType: "road",
    elementType: "all",
    stylers: [{
      saturation: -100
    }, {
      lightness: 45
    }]
  }, {
    featureType: "road.highway",
    elementType: "all",
    stylers: [{
      visibility: "simplified"
    }]
  }, {
    featureType: "road.highway",
    elementType: "geometry.fill",
    stylers: [{
      weight: "0.8"
    }]
  }, {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [{
      weight: "0.8"
    }]
  }, {
    featureType: "road.highway",
    elementType: "labels",
    stylers: [{
      visibility: "off"
    }]
  }, {
    featureType: "road.highway",
    elementType: "labels.text.fill",
    stylers: [{
      weight: "0.8"
    }]
  }, {
    featureType: "road.highway",
    elementType: "labels.text.stroke",
    stylers: [{
      weight: "0.01"
    }]
  }, {
    featureType: "road.arterial",
    elementType: "geometry.stroke",
    stylers: [{
      weight: "0"
    }]
  }, {
    featureType: "road.arterial",
    elementType: "labels.icon",
    stylers: [{
      visibility: "off"
    }]
  }, {
    featureType: "road.local",
    elementType: "geometry.stroke",
    stylers: [{
      weight: "0.01"
    }]
  }, {
    featureType: "road.local",
    elementType: "labels.text",
    stylers: [{
      visibility: "off"
    }]
  }, {
    featureType: "transit",
    elementType: "all",
    stylers: [{
      visibility: "off"
    }]
  }, {
    featureType: "water",
    elementType: "all",
    stylers: [{
      color: "#e4e4e4"
    }, {
      visibility: "on"
    }]
  }], e.dark_label = [{
    featureType: "all",
    elementType: "labels",
    stylers: [{
      visibility: "off"
    }]
  }, {
    featureType: "all",
    elementType: "labels.text.fill",
    stylers: [{
      saturation: 36
    }, {
      color: "#000000"
    }, {
      lightness: 40
    }]
  }, {
    featureType: "all",
    elementType: "labels.text.stroke",
    stylers: [{
      visibility: "on"
    }, {
      color: "#000000"
    }, {
      lightness: 16
    }]
  }, {
    featureType: "all",
    elementType: "labels.icon",
    stylers: [{
      visibility: "off"
    }]
  }, {
    featureType: "administrative",
    elementType: "geometry.fill",
    stylers: [{
      color: "#000000"
    }, {
      lightness: 20
    }]
  }, {
    featureType: "administrative",
    elementType: "geometry.stroke",
    stylers: [{
      color: "#000000"
    }, {
      lightness: 17
    }, {
      weight: 1.2
    }]
  }, {
    featureType: "administrative",
    elementType: "labels",
    stylers: [{
      visibility: "simplified"
    }, {
      lightness: "-82"
    }]
  }, {
    featureType: "administrative",
    elementType: "labels.text.stroke",
    stylers: [{
      invert_lightness: !0
    }, {
      weight: "7.15"
    }]
  }, {
    featureType: "landscape",
    elementType: "geometry",
    stylers: [{
      color: "#000000"
    }, {
      lightness: 20
    }]
  }, {
    featureType: "landscape",
    elementType: "labels",
    stylers: [{
      visibility: "off"
    }]
  }, {
    featureType: "poi",
    elementType: "all",
    stylers: [{
      visibility: "off"
    }]
  }, {
    featureType: "poi",
    elementType: "geometry",
    stylers: [{
      color: "#000000"
    }, {
      lightness: 21
    }]
  }, {
    featureType: "road",
    elementType: "labels",
    stylers: [{
      visibility: "simplified"
    }]
  }, {
    featureType: "road.highway",
    elementType: "geometry.fill",
    stylers: [{
      color: "#000000"
    }, {
      lightness: 17
    }, {
      weight: "0.8"
    }]
  }, {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [{
      color: "#000000"
    }, {
      lightness: 29
    }, {
      weight: "0.01"
    }]
  }, {
    featureType: "road.highway",
    elementType: "labels",
    stylers: [{
      visibility: "off"
    }]
  }, {
    featureType: "road.arterial",
    elementType: "geometry",
    stylers: [{
      color: "#000000"
    }, {
      lightness: 18
    }]
  }, {
    featureType: "road.arterial",
    elementType: "geometry.stroke",
    stylers: [{
      weight: "0.01"
    }]
  }, {
    featureType: "road.local",
    elementType: "geometry",
    stylers: [{
      color: "#000000"
    }, {
      lightness: 16
    }]
  }, {
    featureType: "road.local",
    elementType: "geometry.stroke",
    stylers: [{
      weight: "0.01"
    }]
  }, {
    featureType: "road.local",
    elementType: "labels",
    stylers: [{
      visibility: "off"
    }]
  }, {
    featureType: "transit",
    elementType: "all",
    stylers: [{
      visibility: "off"
    }]
  }, {
    featureType: "transit",
    elementType: "geometry",
    stylers: [{
      color: "#000000"
    }, {
      lightness: 19
    }]
  }, {
    featureType: "water",
    elementType: "geometry",
    stylers: [{
      color: "#000000"
    }, {
      lightness: 17
    }]
  }];

  function t(t) {
    return e[t]
  }

  const l = {};

  // This 's' function is your script loader. It needs to correctly set up the global 'google' object
  // via the callback parameter for the Google Maps API script.
  function s(e = {}) {
    if (e.type || (e.type = "json"), e.url) return l[e.url] ? l[e.url] : function(e_url, e_type) {
      const scriptLoadPromise = new Promise(((resolve, reject) => {
        // We're going to use the Google Maps API's 'callback' parameter directly
        // The callback function will be global so the Google Maps script can find it.
        window.initGoogleMapComponents = () => {
          resolve(); // Resolve the promise when the Google Maps script calls our global callback
        };

        const script = document.createElement('script');
        script.src = `${e_url}&callback=initGoogleMapComponents`; // Crucial: add callback
        script.async = true;
        script.defer = true; // Use defer for non-blocking load
        script.onerror = () => {
          reject(new Error("Failed to load Google Maps script."));
        };
        document.head.appendChild(script);
      }));
      l[e_url] = scriptLoadPromise; // Store the promise
      return scriptLoadPromise;
    }(e.url, e.type);

    // ... (rest of your s function for json/name, likely not relevant for maps API) ...
    if (e.json) return l[e.json]?Promise.resolve(l[e.json]):window.fetch(e.json).then((e=>e.json())).then((t=>(l[e.json]=t,t)));
    if (e.name) {
      const t = "".concat(e.name, e.version);
      return l[t] ? l[t] : function(e) {
        const t = "".concat(e.name, e.version),
          s = new Promise(((t, l) => {
            try {
              window.Shopify.loadFeatures([{
                name: e.name,
                version: e.version,
                onLoad: e => {
                  !function(e, t, l) {
                    l ? t(l) : e()
                  }(t, l, e)
                }
              }])
            } catch (e) {
              l(e)
            }
          }));
        return l[t] = s, s
      }(e)
    }
    return Promise.reject()
  }

  window.theme.mapAPI = window.theme.mapAPI || null;

  customElements.get("map-component") || customElements.define("map-component", class extends HTMLElement {
    constructor() {
      super();
      this.key = this.getAttribute("data-api-key");
      this.styleString = this.getAttribute("data-style") || "";
      this.zoomString = this.getAttribute("data-zoom") || 14;
      this.addressesData = this.getAttribute("data-addresses"); // Changed from data-address
      this.locations = this.parseAddressesData(this.addressesData); // New: Parse the multiple addresses
      this.map = null; // Initialize map to null
      this.markers = []; // Array to store map markers
      this.geocoder = null;
      // Initialize bounds here. 'google' might not be fully loaded yet,
      // but this is just creating an object, not using Google Maps methods yet.
      
    }

    connectedCallback() {
      if (this.key && this.locations.length > 0) { // Ensure there are locations to display
        this.initMaps();
      } else if (this.key && this.locations.length === 0) {
        console.warn("Map component loaded, but no addresses were provided.");
      }
    }

    // New method to parse the concatenated address string
    parseAddressesData(addressesString) {
      const locations = [];
      if (addressesString) {
        // Split by location separator (e.g., ';')
        const addressEntries = addressesString.split(';').filter(entry => entry.trim() !== '');

        addressEntries.forEach(entry => {
          // Split each entry by data separator (e.g., '|')
          const parts = entry.split('|');
          // Expected format: address|lat|long|lat_long_correction
          if (parts.length === 4) {
            locations.push({
              address: parts[0],
              lat: parseFloat(parts[1]) || null,
              long: parseFloat(parts[2]) || null,
              enableCorrection: parts[3] === 'true'
            });
          } else {
            console.warn("Malformed address entry in data-addresses:", entry);
          }
        });
      }
      return locations;
    }

    initMaps() {
      // Ensure the Google Maps API is loaded before proceeding
      (function(apiKey) {
        if (null === window.theme.mapAPI) {
          const scriptUrl = `https://maps.googleapis.com/maps/api/js?key=${apiKey}`;
          window.theme.mapAPI = s({ url: scriptUrl }); // This `s` function needs the callback logic
        }
        return window.theme.mapAPI;
      })(this.key).then(() => {
        // Now 'google' object is guaranteed to be defined
        this.bounds = new google.maps.LatLngBounds();
        this.map = new google.maps.Map(this, {
          
          zoom: parseInt(this.zoomString, 10),
          styles: t(this.styleString),
          center: { lat: 0, lng: 0 }, // Will be updated by fitBounds
          draggable: !0,
          clickableIcons: !1,
          scrollwheel: !1,
          zoomControl: !1,
          disableDefaultUI: !0
        });

        

        this.geocoder = new google.maps.Geocoder();

        this.addMarkersForLocations();

        // Add resize listener to the map itself, not window, and use bounds
        google.maps.event.addDomListener(window, "resize", () => {
            google.maps.event.trigger(this.map, "resize");
            if (this.markers.length > 0) {
                this.map.fitBounds(this.bounds);
            }
        });

      }).catch((e => {
        console.log("Failed to load Google Map"), console.log(e);
      }));
    }

    addMarkersForLocations() {
        // Create an array of promises for geocoding
        const geocodePromises = this.locations.map(location => {
            return new Promise((resolve, reject) => {
                if (location.enableCorrection && location.lat && location.long) {
                    const position = { lat: location.lat, lng: location.long };
                    resolve({ position: position, title: location.address });
                } else {
                    // Ensure geocoder is defined before using it
                    if (this.geocoder) {
                      this.geocoder.geocode({ address: location.address }, (results, status) => {
                          if (status === 'OK' && results[0]) {
                              const position = results[0].geometry.location;
                              resolve({ position: position, title: location.address });
                          } else {
                              console.error('Geocode was not successful for ' + location.address + ': ' + status);
                              reject(status); // Reject if geocoding fails
                          }
                      });
                    } else {
                        reject("Geocoder not initialized.");
                    }
                }
            });
        });

        // Wait for all geocoding promises to resolve
        Promise.allSettled(geocodePromises)
            .then(results => {
                results.forEach(result => {
                    if (result.status === 'fulfilled') {
                        const { position, title } = result.value;
                        const marker = new google.maps.Marker({
                            map: this.map,
                            position: position,
                            title: title
                        });
                        this.markers.push(marker); // Store the marker
                        this.bounds.extend(position); // Extend bounds to include this marker
                    }
                });

                // Fit map to bounds after all markers are added
                if (this.markers.length > 0) {
                    this.map.fitBounds(this.bounds);

                    // If there's only one marker, set its zoom
                    // You might want to remove this if you always want fitBounds to control zoom
                    // if (this.markers.length === 1) {
                    //     this.map.setZoom(parseInt(this.zoomString, 6));
                    // } else {
                    //   this.map.setZoom(parseInt(this.zoomString, 3));
                    // }
                } else {
                    console.warn("No markers were added to the map. Check addresses or API key.");
                }
            });
    }

    disconnectedCallback() {
      if (this.map) {
        google.maps.event.clearListeners(this.map, "resize");
      }
    }
  });
}();